import { createClient } from "@sanity/client";
import { normalizePublicId } from "./cloudinary";
import { getProjectVideos } from "./data";

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID;
const dataset = process.env.REACT_APP_SANITY_DATASET || "production";

export const isSanityConfigured = Boolean(projectId && projectId !== "your-project-id");

export const sanityClient = isSanityConfigured
  ? createClient({
      projectId,
      dataset,
      apiVersion: "2024-01-01",
      useCdn: true,
    })
  : null;

function normalizeIdList(ids) {
  return (ids || []).map(normalizePublicId).filter(Boolean);
}

export function normalizeProject(doc) {
  if (!doc) return null;
  const videos = getProjectVideos({ videos: doc.videos });
  return {
    slug: doc.slug,
    title: doc.title,
    client: doc.client,
    industry: doc.industry,
    services: doc.services || [],
    videos,
    cover: normalizePublicId(doc.cover),
    photography: normalizeIdList(doc.photography),
    color: doc.color || "#000000",
    tagline: doc.tagline || "",
    challenge: doc.challenge || "",
    direction: doc.direction || "",
    featured: Boolean(doc.featured),
    hideOverview: Boolean(doc.hideOverview),
    sortOrder: doc.sortOrder ?? 0,
  };
}

export function normalizeTestimonial(doc) {
  if (!doc) return null;
  return {
    quote: doc.quote || "",
    author: doc.author || "",
    sortOrder: doc.sortOrder ?? 0,
    featured: Boolean(doc.featured),
  };
}
